export enum ViewModels {
	SELECT_OPTION = "select_option",
	TABLE_ROW = "table_row",
}
